import script from "./starton.vue?vue&type=script&setup=true&lang=js"
export * from "./starton.vue?vue&type=script&setup=true&lang=js"

import "./starton.vue?vue&type=style&index=0&id=afb23716&lang=css"

const __exports__ = script;

export default __exports__